import { useEffect } from 'react';

const AppExperienceSwitcher = ({ experience }) => {
  useEffect(() => {
    document.cookie = `app_experience=${experience}; path=/; max-age=604800`;
    window.location.replace('/');
  }, []);

  return <p className="m-4">Switching to {experience} Consumer app...</p>;
};

export default AppExperienceSwitcher;
